module.exports = "/assets/images/play_d367c8.svg";